<ng-container *ngIf="question && question.examEssaySubQuestions?.length">
    <div class="sr-only" aria-live="polite">
        {{ question.examEssaySubQuestions.length }} {{ language.subQuestions }}
    </div>

    <div *ngFor="let subQuestion of question.examEssaySubQuestions; let i = index; let isLast = last">
        <div class="col-lg-12 d-flex flex-column px-3">

            <!-- Sub-question prompt -->
            <div class="flex-row mt-3" style="display: flex; align-items: flex-start; gap: 20px;" tabindex="0"
                [attr.aria-label]="
        language.subQuestion + ' ' +
        subQuestion.questionnolabel + ' ' +
        language.questionIs + ' ' +
        subQuestion.questionhtml
      ">
                <div style="
          font-size: 1.25rem !important;
          font-weight: 600;
          font-family: Poppins !important;
          flex-shrink: 0;
          color: #5c768d;
        ">
                    {{ subQuestion.questionnolabel }}.
                </div>
                <section class="lead main my-0 py-0" style="
          font-size: 18px !important;
          color: #000;
          font-family: Poppins !important;
          flex: 1;
        " [innerHTML]="subQuestion.questionhtml"></section>
            </div>

            <div class="text-center px-2 pb-1 paddedrow questionborder" style="width: 100%;"></div>

            <!-- Editor for this sub-question -->
            <div class="section-title">
                <div class="mt-2" aria-hidden="true"></div>
            </div>

            <div class="row">
                <div class="col" style="text-align: left;">
                    <span *ngIf="wordCounts[i]" aria-live="polite" aria-atomic="true">{{ wordCounts[i] }}</span>
                </div>
                <div class="col" style="text-align: right;">
                    <span *ngIf="question.examQuestion.maxwordcount" style="color: red;" aria-live="polite"
                        aria-atomic="true">
                        {{ language.limitOf }} {{ question.examQuestion.maxwordcount }} {{ language.wordsMaximum }}
                    </span>
                </div>
            </div>

            <div style="width: 100% !important;" spellcheck="false">
                <app-quill-editor required [attr.data-subquestion-index]="i"
                    [placeholder]="language.quillEditorPlaceHolderMessage"
                    [readOnlyMessage]="language.quillEditorEssayReadOnlyMessage"
                    (valueChange)="onEditorContentChange($event, i)" (editorCreated)="onEditorCreated(i)"
                    [maxWordCount]="question.examQuestion.maxwordcount" #editors></app-quill-editor>
            </div>

            <div class="row">
                <div class="col" style="text-align: left;">
                    <span *ngIf="wordCounts[i]" aria-hidden="true">{{ wordCounts[i] }}</span>
                </div>
                <div class="col" style="text-align: right;">
                    <span *ngIf="question.examQuestion.maxwordcount" style="color: red;" aria-hidden="true">
                        {{ language.limitOf }} {{ question.examQuestion.maxwordcount }} {{ language.wordsMaximum }}
                    </span>
                </div>
            </div>

            <div class="mt-2 text-muted small" *ngIf="lastSavedTime" role="status" aria-live="polite">
                <em>{{ language.lastSavedAuto ?? 'Last saved (auto)' }}: {{ getLastSavedText() }}</em>
            </div>

        </div>

        <!-- Divider between sub-questions (not after last) -->
        <div *ngIf="!isLast" class="row ml-1 pb-3 paddedrow questionborder" style="width: 100%;"></div>
    </div>
</ng-container>